import React from 'react'
import PropTypes from 'prop-types'

function Icon({ iconData }) {
  return (
    <a
      href={iconData.url}
      target="_blank"
      rel="noopener noreferrer"
      data-event={iconData.image.title}
    >
      <img src={iconData.image.file.url} alt={iconData.image.title} />
    </a>
  )
}

Icon.propTypes = {
  iconData: PropTypes.object.isRequired
}

export default Icon
